import React from 'react';
import { Input, Label } from 'reactstrap';
import Swal from 'sweetalert2';

const AgreeLockButton = ({ isLocked = false, onLock, disabled = false }) => {
  const canToggle = typeof onLock === 'function';

  const handleAgree = async () => {
    const result = await Swal.fire({
      title: 'Agree / No Clarification Needed?',
      text: 'This marks the item as agreed. No further clarification will be needed.',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#0ab39c',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Yes, Agree',
      cancelButtonText: 'Cancel',
    });
    if (!result.isConfirmed) return;
    await onLock(true);
  };

  const handleUnlock = async () => {
    const result = await Swal.fire({
      title: 'Unlock agreement?',
      text: 'This item will need to be agreed or responded to again before sending clarification.',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#f1556c',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Yes, Unlock',
      cancelButtonText: 'Cancel',
    });
    if (!result.isConfirmed) return;
    await onLock(false);
  };

  const handleToggle = async () => {
    if (isLocked) {
      await handleUnlock();
      return;
    }
    await handleAgree();
  };

  if (!canToggle && !isLocked) return null;

  const isInteractive = canToggle && !disabled;

  return (
    <Label
      className={`rounded-3 border px-3 py-2 w-100 d-flex align-items-center justify-content-between gap-3 mb-0 user-select-none ${
        isLocked
          ? 'border-primary-subtle bg-primary-subtle text-primary'
          : 'border-success bg-success-subtle text-success shadow-sm'
      }`}
      style={{
        cursor: isInteractive ? 'pointer' : 'not-allowed',
        opacity: isInteractive ? 1 : 0.65,
      }}
    >
      <span className='fs-13 fw-semibold d-flex align-items-center gap-2'>
        <i
          className={`bx ${isLocked ? 'bx-lock-alt text-primary' : 'bx-lock-alt text-success'} fs-16`}
        ></i>
        {isLocked ? 'Agreed' : 'Agree & Lock'}
      </span>
      <div
        className='form-check form-switch mb-0 p-0 d-flex align-items-center'
        style={{ minHeight: 'auto' }}
      >
        <Input
          type='switch'
          role='switch'
          checked={isLocked}
          disabled={!isInteractive}
          onChange={handleToggle}
          className='m-0 float-none'
          style={{ cursor: isInteractive ? 'pointer' : 'not-allowed' }}
        />
      </div>
    </Label>
  );
};

export default AgreeLockButton;
